import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import qs from 'query-string'
import ReactHtmlParser from 'react-html-parser'
import { BrowserView, MobileView, isMobile } from 'react-device-detect'

import contentCardData from '../ContentCard/ContentCard.json'
import maternityContentCardData from '../ContentCard/MaternityContentCards.json'
import hfiaContentCardData from '../ContentCard/HFIAContentCards.json'

import Loader from '../Loader/Loader'
import ContentCardDemo from '../ContentCard/ContentCardDemo'
import Filters from '../Filters/Filters'
import FiltersPlaceholder from '../FiltersPlaceholder/FiltersPlaceholder'
import Variant from '../Variant/Variant'
import SortBy from '../SortBy/SortBy'
import useStateCallback from '../../hooks/useStateCallback'

import './CollectionPlaceholder'

import './Collections.scss'

import {
    getShuffledArray,
    getUniqueListBy,
    dynamicSort,
    sortByKey,
    multiFilter,
    slugify,
    insertParam,
    insertUrlParam,
    removeParam,
    formatQueryStringValues,
    removeQueryString,
    getProducts,
    getFirstProducts,
    getNextProducts,
    getFilteredFilters,
    insert,
} from '../../helpers/helpers'
import CollectionPlaceholder from './CollectionPlaceholder'



const queryString = window.location.search
const parsed = qs.parse(queryString)

console.log('parsed up here', parsed, queryString)

let slug = window.location.href.split('/').pop()

console.log('contentCardData', contentCardData)

let contentCards
let maternityContentCards
let hfiaContentCards

if (contentCardData) {
    contentCards = contentCardData.contentCards
}

// console.log('contentCards', contentCards)

if (maternityContentCardData) {
    maternityContentCards = maternityContentCardData.contentCards
}

if (hfiaContentCardData) {
    hfiaContentCards = hfiaContentCardData.contentCards
}

const Collection = React.memo(
    ({
        collectionData,
        collectionHandle,
        cid,
        collectionId,
        collectionPage,
    }) => {
        // console.log('collectionId in Collection.js', collectionId)
        const [data, setData] = useStateCallback()
        const [numProducts, setNumProducts] = useStateCallback(0)
        const [numProductsRemaining, setNumProductsRemaining] =
            useStateCallback(0)
        const [pages, setPages] = useStateCallback(0)
        const [currentPage, setCurrentPage] = useStateCallback(1)
        const [initialData, setInitialData] = useStateCallback()
        const [variants, setVariants] = useStateCallback()
        const [filters, setFilters] = useStateCallback()
        const [isFiltering, setIsFiltering] = useStateCallback(false)
        const [showFilters, setShowFilters] = useState(false)

        const variantsWithInventoryRef = useRef()
        const [sortBy, setSortBy] = useState('')
        const [isLoading, setIsLoading] = useState(false)
        const [hasProducts, setHasProducts] = useState(true)

        const boostQueryUrl = useRef()

        let collectionTitle
        let collectionDesc
        let uniqueVariants
        let products
        let allVariants
        let hiddenProduct

        if (
            !collectionId ||
            collectionId === 'undefined' ||
            collectionId === ''
        ) {
            // find the collection by handle/slug
            if (cid && cid.length) {
                collectionId = cid
            } else if (collectionData && collectionData.length) {
                collectionData.map((c) => {
                    // eslint-disable-next-line
                    if (c.handle == collectionHandle) {
                        // console.log('c', c)
                        collectionId = c.id
                        collectionTitle = c.title
                        collectionDesc = c['body-html']
                    }
                    return null
                })
            }

            if (collectionHandle === 'halloween') {
                collectionId = 262594396222
            }
        }

        let boostLiveUrl

        if (collectionId && collectionId === '268040110142') {
            boostLiveUrl = 'https://services.mybcapps.com/bc-sf-filter/filter?shop=monicaandandyonline.myshopify.com&limit=70&collection_scope='
        } else {
            boostLiveUrl = 'https://services.mybcapps.com/bc-sf-filter/filter?shop=monicaandandyonline.myshopify.com&product_available=true&variant_available=true&limit=70&collection_scope='
        }

        let filterUrl

        if (collectionId && collectionId === '268040110142') {
            filterUrl = `https://services.mybcapps.com/bc-sf-filter/filter?shop=monicaandandyonline.myshopify.com&limit=70&page=1&collection_scope=${collectionId}&build_filter_tree=true`
        } else {
            filterUrl = `https://services.mybcapps.com/bc-sf-filter/filter?shop=monicaandandyonline.myshopify.com&limit=70&page=1&collection_scope=${collectionId}&product_available=true&variant_available=true&build_filter_tree=true`
        }

        useEffect(() => {
            // get query string + parse
            const terms = [
                'pf_opt_size',
                'pf_opt_pattern',
                'pf_pt_product_type',
                'pf_opt_gender',
            ]

            // check if we have any filter params
            let termsFound = Object.keys(parsed).some((k) => terms.includes(k))

            let initialFilters

            // we don't have any filters (but could have utm params)
            if (!queryString) {
                fetch(filterUrl).then((res) =>
                    res.json().then((productData) => {
                        console.log('productData in getNumProducts', productData)


                        // write backup date to file on server every Saturday at 2am
                        let run = false
                        const now = new Date()
                        const isoDate = new Date()
                            .toISOString()
                            .substring(0, 10)
                        if (
                            now.getDay() === 6 &&
                            now.getHours() === 2 &&
                            now.getMinutes() === 0 &&
                            !run
                        ) {
                            fetch(
                                'https://data.monicaandandy.com/plp/data/input.php',
                                {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                        data: productData,
                                        collectionTitle: `${collectionHandle}`,
                                    }),
                                }
                            )
                                .then((res) => res.json())
                                .then((data) => {
                                    if (data.status == 200) {
                                        //when data is returned from backend
                                        const response = data.response
                                        console.log(response) //should print dataReceived
                                    }
                                })
                            run = true
                        }

                        let numberOfProducts = productData.total_product
                        setNumProducts(numberOfProducts)

                        let pages

                        // calculate number of "pages" of data in collection
                        if (numberOfProducts) {
                            pages = Math.ceil(numberOfProducts / 70)
                        }

                        setPages(pages)

                        // console.log('pages', pages)

                        setNumProductsRemaining(numberOfProducts - 70)

                        setData(productData.products.flat(1))
                        if (!initialData) {
                            setInitialData(productData.products.flat(1))
                        }

                        initialFilters = getFilteredFilters([
                            ...productData.filter.options,
                        ])

                        initialFilters = initialFilters.map((f) => {
                            // console.log('f in initialFilters', f)
                            if (
                                f.filterType === 'opt_size' ||
                                f.filterType === 'opt_pattern' ||
                                f.filterType === 'product_type' ||
                                f.filterType === 'opt_gender'
                            ) {
                                return {
                                    ...f,
                                    values: f.values.map((v) => {
                                        // console.log('v in newFilters', v)
                                        return {
                                            ...v,
                                            selected: false,
                                        }
                                    }),
                                }
                            }
                            return f
                        })

                        console.log('initialFilters', initialFilters)
                        setFilters(initialFilters)
                    })
                )
            } else {
                // we have filters
                console.log('we have query string', queryString)
                let formattedQueryString = queryString

                formattedQueryString = formattedQueryString.replace(
                    /pf_opt_size=/g,
                    'pf_opt_size[]='
                )
                formattedQueryString = formattedQueryString.replace(
                    /pf_opt_pattern=/g,
                    'pf_opt_pattern[]='
                )
                formattedQueryString = formattedQueryString.replace(
                    /pf_pt_product_type=/g,
                    'pf_pt_product_type[]='
                )

                formattedQueryString = formattedQueryString.replace(
                    /pf_opt_gender=/g,
                    'pf_opt_gender[]='
                )
                formattedQueryString = formattedQueryString.replace(/ /g, '%20')
                formattedQueryString = formattedQueryString.replace('?', '&')

                console.log('formattedQueryString', formattedQueryString)

                let formattedQueryUrl = `${boostLiveUrl}${collectionId}${formattedQueryString}&build_filter_tree=true`

                console.log('formattedQueryUrl', formattedQueryUrl)

                // query the api with filter params to get first products + filters
                getFirstProducts(formattedQueryUrl).then((productData) => {
                    console.log('productData with queryString', productData)

                    let numberOfProducts = productData.total_product
                    setNumProducts(numberOfProducts)

                    setNumProductsRemaining(numberOfProducts - 70)

                    setData(productData.products.flat(1))
                    if (!initialData) {
                        setInitialData(productData.products.flat(1))
                    }

                    initialFilters = getFilteredFilters([
                        ...productData.filter.options,
                    ])

                    initialFilters = initialFilters.map((f) => {
                        // console.log('f in newFilters after click', f)
                        if (
                            f.filterType === 'opt_size' ||
                            f.filterType === 'opt_pattern' ||
                            f.filterType === 'product_type' ||
                            f.filterType === 'opt_gender'
                        ) {
                            return {
                                ...f,
                                values: f.values.map((v) => {
                                    // console.log('v in newFilters', v)
                                    let selected = false
                                    if (parsed.pf_opt_size) {
                                        let sizeValues =
                                            formatQueryStringValues(
                                                parsed.pf_opt_size
                                            )
                                        sizeValues.map((p) => {
                                            if (p === v.key) {
                                                selected = true
                                            }
                                            return null
                                        })
                                    }
                                    if (parsed.pf_opt_pattern) {
                                        let printValues =
                                            formatQueryStringValues(
                                                parsed.pf_opt_pattern
                                            )

                                        printValues.map((p) => {
                                            if (p === v.key) {
                                                selected = true
                                            }
                                            return null
                                        })
                                    }
                                    if (parsed.pf_pt_product_type) {
                                        let typeValues =
                                            formatQueryStringValues(
                                                parsed.pf_pt_product_type
                                            )
                                        typeValues.map((p) => {
                                            if (p === v.key) {
                                                selected = true
                                            }
                                            return null
                                        })
                                    }
                                    if (parsed.pf_opt_gender) {
                                        let genderValues =
                                            formatQueryStringValues(
                                                parsed.pf_opt_gender
                                            )
                                        genderValues.map((p) => {
                                            if (p === v.key) {
                                                selected = true
                                            }
                                            return null
                                        })
                                    }
                                    return {
                                        ...v,
                                        selected: selected,
                                    }
                                }),
                            }
                        }
                        return f
                    })

                    console.log('initialFilters with queryString', initialFilters)

                    setFilters(initialFilters)

                    // fetch(filterUrl).then((res) =>
                    //     res.json().then((filterData) => {
                    //         initialFilters = getFilteredFilters([
                    //             ...filterData.filter.options,
                    //         ])

                    //         initialFilters = initialFilters.map((f) => {
                    //             // console.log('f in initialFilters', f)
                    //             if (
                    //                 f.filterType === 'opt_size' ||
                    //                 f.filterType === 'opt_pattern' ||
                    //                 f.filterType === 'product_type' ||
                    //                 f.filterType === 'opt_gender'
                    //             ) {
                    //                 return {
                    //                     ...f,
                    //                     values: f.values.map((v) => {
                    //                         // console.log('v in newFilters', v)
                    //                         return {
                    //                             ...v,
                    //                             selected: false,
                    //                         }
                    //                     }),
                    //                 }
                    //             }
                    //             return f
                    //         })
                    //         console.log('initialFilters after fetch on load', initialFilters)
                    //         setFilters(initialFilters)
                    //     })
                    // )
                })
            }
            // eslint-disable-next-line
        }, [])

        // set our variants
        useEffect(() => {
            if (uniqueVariants && uniqueVariants.length) {
                if (
                    collectionPage &&
                    collectionPage === 'giveaway' &&
                    (collectionId === 266036805694 ||
                        collectionId === '266036805694')
                ) {
                    // console.log('babylist collection', collectionId)
                    const uniqueVariants1 = uniqueVariants.slice(0, 16)
                    // console.log('uniqueVariants1', uniqueVariants1)
                    setVariants(uniqueVariants1)
                } else if (numProducts <= 70) {
                    console.log('uniqueVariants', uniqueVariants)
                    setVariants(uniqueVariants)
                    setNumProductsRemaining(0)
                    // console.log('if = here')
                } else {
                    if (collectionId === 267491377214 || collectionId === '267491377214' ) {
                        let uniqueVariants1 = insert(uniqueVariants, 7, contentCards[0])

                        uniqueVariants1 = insert(uniqueVariants1, 13, contentCards[1])
                        uniqueVariants1 = insert(uniqueVariants1, 23, contentCards[2])
                        uniqueVariants1 = insert(uniqueVariants1, 40, contentCards[3])
                        console.log('uniqueVariants1', uniqueVariants1)
                        setVariants(uniqueVariants1)
                    } else if (collectionId === 267603378238 || collectionId === '267603378238') {
                        let uniqueVariants1 = insert(uniqueVariants, 7, maternityContentCards[0])

                        uniqueVariants1 = insert(uniqueVariants1, 12, maternityContentCards[1])
                        uniqueVariants1 = insert(uniqueVariants1, 23, maternityContentCards[2])
                        uniqueVariants1 = insert(uniqueVariants1, 28, maternityContentCards[3])
                        console.log('uniqueVariants1', uniqueVariants1)
                        setVariants(uniqueVariants1)
                    } else if (collectionId === 267989024830 || collectionId === '267989024830') {
                        let uniqueVariants1 = insert(uniqueVariants, 0, hfiaContentCards[0])

                        uniqueVariants1 = insert(uniqueVariants1, 9, hfiaContentCards[1])

                        setVariants(uniqueVariants1)
                    } else {
                        setVariants(uniqueVariants)
                        console.log('setting unique, numProductsRemaining', numProductsRemaining)
                    }

                    console.log('else = here')
                }
            } else {
                setHasProducts(uniqueVariants !== null)
                console.log('else else = here')
            }
            // eslint-disable-next-line
        }, [data, uniqueVariants])

        useEffect(() => {
            if (queryString && queryString.indexOf('sort')) {
                // console.log('parsed in useEffect', parsed)
                const parsedSort = parsed['sort']
                setSortBy(parsedSort)
            }
        }, [])

        // remove any query strings from url when cleared
        const handleClearAll = async () => {
            setIsFiltering(true)
            setVariants(null)
            window.history.replaceState(null, null, window.location.pathname)
            let initialFilters
            fetch(filterUrl).then((res) =>
                res.json().then((productData) => {
                    // console.log('productData in getNumProducts', productData)
                    let numberOfProducts = productData.total_product
                    setNumProducts(numberOfProducts)

                    setNumProductsRemaining(numberOfProducts - 70)

                    setData(productData.products.flat(1))

                    if (!initialData) {
                        setInitialData(productData.products.flat(1))
                    }

                    initialFilters = getFilteredFilters([
                        ...productData.filter.options,
                    ])

                    initialFilters = initialFilters.map((f) => {
                        // console.log('f in initialFilters', f)
                        if (
                            f.filterType === 'opt_size' ||
                            f.filterType === 'opt_pattern' ||
                            f.filterType === 'product_type' ||
                            f.filterType === 'opt_gender'
                        ) {
                            return {
                                ...f,
                                values: f.values.map((v) => {
                                    // console.log('v in newFilters', v)
                                    return {
                                        ...v,
                                        selected: false,
                                    }
                                }),
                            }
                        }
                        return f
                    })

                    setFilters(initialFilters)
                })
            )

            setIsFiltering(false)
        }

        const handleSort = async (value) => {
            console.log('sortby value', value)
            setIsFiltering(true)
            setSortBy(value)

            let sv = []
            let queryUrl = ''

            // const queryString = window.location.search

            // const parsed = qs.parse(queryString)

            const parsedSort = parsed['sort']

            console.log('parsedSort', parsedSort)
            if (queryString) {
                if (parsedSort) {
                    console.log('parsedSort true', parsedSort)
                    removeQueryString('sort', parsedSort)
                    insertParam('sort', value)
                } else {
                    console.log('no parsed.sort')
                }
            } else {
                console.log('no querystring in sortby')
                insertParam('sort', value)
            }

            if (value === 'new-arrivals') {
                // console.log('sorted by new arrivals')
                sv = variants.sort(dynamicSort('created_at'))
            }
            // if (value === 'best-selling') {
            //     console.log('sorted by best-selling')
            //     queryUrl = `${filterUrl}${collectionId}&sort=${value}&product_available=true&variant_available=true`

            // }

            if (value === 'low-high') {
                sv = sortByKey(variants, 'price')
                console.log('sorted by low-high', sv)
            }
            if (value === 'high-low') {
                sv = sortByKey(variants, 'price')
                sv = sv.reverse()
            }
            if (value === 'a-z') {
                // console.log('a-z')
                sv = variants.sort(dynamicSort('product_title'))
            }
            if (value === 'z-a') {
                sv = variants.sort(dynamicSort('product_title'))
                sv = sv.reverse()
            }
            if (sv.length) {
                setTimeout(() => {
                    console.log('sv', sv)
                    setVariants(sv)
                    setIsFiltering(false)
                }, 10)
            }
        }

        if (data && data) {
            // console.log('data after query', data)
            products = [...data]

            let variants = products.map((p) => {
                return p.variants
            })

            variants = variants.flat(2)

            // console.log('variants', variants)

            let productTimes = products.map((p) => {
                // console.log('p, p.title', p, p.title)
                return {
                    product_id: p.id,
                    created_at: p.created_at,
                    product_title: p.title,
                }
            })

            // we don't have a 'gender' property by default; add it for filtering
            let variantsWithGender = variants.map((v) => {
                let gender
                const options = v.merged_options
                const genderOption = options.find((o) => o.includes('gender:'))
                if (genderOption) {
                    gender = genderOption.split(':')[1]
                }
                return { ...v, gender: gender ? gender : 'Unisex' }
            })

            let variantsWithTime = []
            variantsWithGender.map((v) => {
                productTimes.map((t) => {
                    if (t.product_id.toString() === v.product_id.toString()) {
                        variantsWithTime.push({
                            ...v,
                            product_title: t.product_title,
                            created_at: t.created_at,
                            id_pattern:
                                v.initial_color && v.initial_color.length
                                    ? t.product_id +
                                      '_' +
                                      slugify(v.initial_color)
                                    : t.product_id + '_one-color',
                        })
                    }
                    return null
                })
                return null
            })

            allVariants = [...variantsWithTime]

            allVariants = [...new Set(allVariants)]

            console.log('allVariants', allVariants)

            let carroVariants = allVariants.filter((v) => {
                if (v.fulfillment_service && v.fulfillment_service.length) {
                    return v.fulfillment_service.indexOf('carro') > -1
                }
                return null
            })

            carroVariants = getUniqueListBy(carroVariants, 'product_id')

            let cortinaVariants = allVariants.filter((v) => {
                if (v.fulfillment_service && v.fulfillment_service.length) {
                    return v.fulfillment_service.indexOf('cortina') > -1
                }
                return null
            })

            cortinaVariants = getUniqueListBy(cortinaVariants, 'product_id')

            // console.log(
            //     'carroVariants, cortinaVariants',
            //     carroVariants,
            //     cortinaVariants
            // )

            const variantsWithInventory = allVariants.filter((x) => {
                return x.inventory_quantity > 0
            })

            variantsWithInventoryRef.current = variantsWithInventory

            let uniques = variantsWithInventory.filter(
                (v, i, a) =>
                    a.findIndex(
                        (t) =>
                            t.product_id === v.product_id &&
                            t.initial_color === v.initial_color
                    ) === i
            )

            // console.log('uniques', uniques)

            const queryString = window.location.search

            if (
                queryString &&
                queryString !== '?_=pf' &&
                queryString.indexOf('sort') === -1
            ) {
                // console.log('query string present')

                // initialize array to hold active filters
                let activeFilters = []

                // use qs library to parse query string
                const parsedQueryString = qs.parse(queryString)

                if (parsedQueryString.pf_opt_size) {
                    activeFilters.push({
                        type: 'size',
                        values: formatQueryStringValues(
                            parsedQueryString.pf_opt_size
                        ),
                    })
                }

                if (parsedQueryString.pf_opt_pattern) {
                    activeFilters.push({
                        type: 'print',
                        values: formatQueryStringValues(
                            parsedQueryString.pf_opt_pattern
                        ),
                    })
                }

                if (parsedQueryString.pf_pt_product_type) {
                    activeFilters.push({
                        type: 'product_type',
                        values: formatQueryStringValues(
                            parsedQueryString.pf_pt_product_type
                        ),
                    })
                }

                if (parsedQueryString.pf_opt_gender) {
                    activeFilters.push({
                        type: 'gender',
                        values: formatQueryStringValues(
                            parsedQueryString.pf_opt_gender
                        ),
                    })
                }

                // console.log('activeFilters', activeFilters)

                const filteredCollected = () => {
                    const collectedTrueKeys = {
                        initial_size: [],
                        initial_color: [],
                        product_type: [],
                        gender: [],
                    }
                    activeFilters.map((s) => {
                        if (s.type === 'size') {
                            s.values.map((v) => {
                                collectedTrueKeys.initial_size.push(v)
                                return null
                            })
                        }
                        if (s.type === 'print') {
                            s.values.map((v) => {
                                collectedTrueKeys.initial_color.push(v)
                                return null
                            })
                        }
                        if (s.type === 'product_type') {
                            s.values.map((v) => {
                                collectedTrueKeys.product_type.push(v)
                                return null
                            })
                        }
                        if (s.type === 'gender') {
                            s.values.map((v) => {
                                collectedTrueKeys.gender.push(v)
                                return null
                            })
                        }
                        return null
                    })

                    return collectedTrueKeys
                }

                let selectedCollected = filteredCollected()

                let filteredVariants = multiFilter(
                    variantsWithInventoryRef.current,
                    selectedCollected
                )

                if (filteredVariants && filteredVariants.length) {
                    uniqueVariants = getUniqueListBy(
                        filteredVariants,
                        'id_pattern'
                    )
                }

                // console.log('data here, uniqueVariants', uniqueVariants)

                // console.log(
                //     'uniques, uniqueVariants, filteredVariants',
                //     uniques,
                //     uniqueVariants,
                //     filteredVariants
                // )
            } else if (queryString && queryString.indexOf('sort')) {
                console.log('sort present', queryString)
                let sv = []
                const parsed = qs.parse(queryString)

                const parsedSort = parsed['sort']

                console.log('parsedSort here', parsedSort)

                if (parsedSort === 'new-arrivals') {
                    // console.log('sorted by new arrivals')
                    sv = uniques.sort(dynamicSort('created_at'))
                }

                if (parsedSort === 'low-high') {
                    sv = sortByKey(uniques, 'price')
                    console.log('sorted by low-high here', sv)
                }
                if (parsedSort === 'high-low') {
                    sv = sortByKey(uniques, 'price')
                    sv = sv.reverse()
                }
                if (parsedSort === 'a-z') {
                    // console.log('a-z')
                    sv = uniques.sort(dynamicSort('product_title'))
                }
                if (parsedSort === 'z-a') {
                    sv = uniques.sort(dynamicSort('product_title'))
                    sv = sv.reverse()
                }
                if (sv.length) {
                    uniqueVariants = sv
                }
            } else {
                console.log('no query string')
                uniqueVariants = [
                    ...uniques,
                    ...carroVariants,
                    ...cortinaVariants,
                ]

                uniqueVariants = getUniqueListBy(uniqueVariants, 'id')

                console.log('data way down here', uniqueVariants)
            }
        }

        const handleFilterClick = async (filterObj) => {
            setIsFiltering(true)
            console.log('filterObj', filterObj)

            const filterType = filterObj.filterType
            const filterValue = filterObj.value
            const filterOption = filterObj.option

            let queryPre = '_'
            let queryPreValue = 'pf'
            let querySize = 'pf_opt_size'
            let queryPrint = 'pf_opt_pattern'
            let queryType = 'pf_pt_product_type'
            let queryGender = 'pf_opt_gender'

            let queryParam
            let queryValue

            if (filterOption === 'opt_size') {
                queryParam = querySize
                queryValue = filterValue
            }
            if (filterOption === 'opt_pattern') {
                queryParam = queryPrint
                queryValue = filterValue
            }
            if (filterOption === 'product_type') {
                queryParam = queryType
                queryValue = filterValue
            }
            if (filterOption === 'opt_gender') {
                queryParam = queryGender
                queryValue = filterValue
            }

            let queryString = window.location.search

            queryString = queryString.replace(/%2520/g, '%20')

            let queryStringReplace = queryString.replace('?', '&')

            let parsedQueryString = qs.parse(queryString)

            let queryUrl = ''
            let clearQueryUrl = ''

            if (queryParam && queryValue) {
                queryParam = queryParam.replace(/ /g, '%20')
                queryValue = queryValue.replace(/ /g, '%20')
                queryValue = queryValue.replace(/\//g, '%2F')
                queryValue = queryValue.replace(/\+/g, '%2B')
                if (queryString) {
                    if (queryValue === 'clear') {
                        // console.log('clear clicked, filterOption', filterOption)
                        removeParam(queryParam)
                        clearQueryUrl = `${boostLiveUrl}${collectionId}${queryStringReplace}&${filterType}${filterValue}&build_filter_tree=true`

                        let regex = ''

                        if (filterOption === 'opt_size') {
                            regex = /&pf_opt_size=[^&]*/
                            // console.log('regex opt_size', regex)
                        }
                        if (filterOption === 'opt_pattern') {
                            regex = /&pf_opt_pattern=[^&]*/
                        }

                        if (filterOption === 'product_type') {
                            regex = /&pf_pt_product_type=[^&]*/
                        }

                        if (filterOption === 'opt_gender') {
                            regex = /&pf_opt_gender=[^&]*/
                        }

                        clearQueryUrl = clearQueryUrl.replace(regex, '')

                        // console.log('clearQueryUrl after clear', clearQueryUrl)

                        queryUrl = clearQueryUrl
                    } else {
                        console.log('query string', queryString)
                        if (
                            queryString.includes(`=${queryValue}`) ||
                            queryString.includes(
                                `=${encodeURIComponent(filterValue)}`
                            )
                        ) {
                            removeQueryString(queryParam, queryValue)
                        } else {
                            console.log('query string new value', queryParam, queryValue)
                            insertUrlParam(queryParam, queryValue)
                        }
                    }
                } else {
                    console.log('this one')
                    if (queryValue !== 'clear') {
                        console.log('queryPre', queryPre)
                        insertParam(queryPre, queryPreValue)
                        insertParam(queryParam, queryValue)
                    } else {
                        // console.log('clear with no query value')
                        // we have no active filters; no need to query API
                        setIsFiltering(false)

                        return
                    }
                }
            } else {
                // console.log('no queryParam after click')
            }

            let queryStringAfterClick = window.location.search

            // Remove params if it's unselected
            if (
                queryStringReplace.includes(
                    `=${encodeURIComponent(filterValue)}`
                ) &&
                !clearQueryUrl
            ) {
                queryStringReplace = queryStringReplace.replace(
                    `${queryParam}=${encodeURIComponent(filterValue)}`,
                    ''
                )
                queryUrl = `${boostLiveUrl}${collectionId}${queryStringReplace}&build_filter_tree=true`
            } else if (!clearQueryUrl) {
                queryUrl = `${boostLiveUrl}${collectionId}${queryStringReplace}&${filterType}${filterValue}&build_filter_tree=true`
            } else {
                queryUrl = clearQueryUrl
            }

            queryUrl = queryUrl.replace(/pf_opt_size=/g, 'pf_opt_size[]=')
            queryUrl = queryUrl.replace(/pf_opt_pattern=/g, 'pf_opt_pattern[]=')
            queryUrl = queryUrl.replace(
                /pf_pt_product_type=/g,
                'pf_pt_product_type[]='
            )
            queryUrl = queryUrl.replace(/pf_opt_gender=/g, 'pf_opt_gender[]=')
            queryUrl = queryUrl.replace(/ /g, '%20')
            queryUrl = queryUrl
                .replace('&pf_opt_pattern[]=clear', '')
                .replace('&pf_opt_size[]=clear', '')
                .replace('&pf_opt_gender[]=clear', '')
                .replace('&pf_pt_product_type[]=clear', '')

            boostQueryUrl.current = queryUrl

            queryUrl = queryUrl.replace(/\+/g, '%2B')

            console.log('queryUrl in filter click', queryUrl)

            // let formattedQueryUrl = `${boostLiveUrl}${collectionId}${queryUrl}&build_filter_tree=true`

            // getFirstProducts(formattedQueryUrl).then((productData) => {
            //     // console.log('productData AFTER CLICK with queryString', productData)
            // })

            let allData = []
            let newFilters = []

            const result = await axios(queryUrl)

            console.log('result', result)

            setNumProducts(result.data.total_product)
            setNumProductsRemaining(result.data.total_product - 70)

            allData.push(result.data.products)
            newFilters = getFilteredFilters([...result.data.filter.options])

            let parsed

            if (queryStringAfterClick) {
                parsed = qs.parse(queryStringAfterClick)
            }

            if (parsed) {
                // console.log('parsed', parsed)

                if (parsed.pf_opt_size) {
                    if (!Array.isArray(parsed.pf_opt_size)) {
                        parsed.pf_opt_size = parsed.pf_opt_size.split()
                    }
                }

                if (parsed.pf_opt_pattern) {
                    if (!Array.isArray(parsed.pf_opt_pattern)) {
                        parsed.pf_opt_pattern = parsed.pf_opt_pattern.split()
                    }
                }

                if (parsed.pf_pt_product_type) {
                    if (!Array.isArray(parsed.pf_pt_product_type)) {
                        parsed.pf_pt_product_type =
                            parsed.pf_pt_product_type.split()
                    }
                }

                if (parsed.pf_opt_gender) {
                    if (!Array.isArray(parsed.pf_opt_gender)) {
                        parsed.pf_opt_gender = parsed.pf_opt_gender.split()
                    }
                }

                // console.log('parsed after format', parsed)

                newFilters = newFilters.map((f) => {
                    // console.log('f in newFilters after click', f)
                    if (
                        f.filterType === 'opt_size' ||
                        f.filterType === 'opt_pattern' ||
                        f.filterType === 'product_type' ||
                        f.filterType === 'opt_gender'
                    ) {
                        return {
                            ...f,
                            values: f.values.map((v) => {
                                // console.log('v in newFilters', v)
                                let selected = false
                                if (parsed.pf_opt_size) {
                                    parsed.pf_opt_size.map((p) => {
                                        if (p === v.key) {
                                            selected = true
                                        }
                                        return null
                                    })
                                }
                                if (parsed.pf_opt_pattern) {
                                    parsed.pf_opt_pattern.map((p) => {
                                        if (p === v.key) {
                                            selected = true
                                        }
                                        return null
                                    })
                                }
                                if (parsed.pf_pt_product_type) {
                                    parsed.pf_pt_product_type.map((p) => {
                                        // console.log('p, v.key', p, v.key)
                                        if (p === v.key) {
                                            selected = true
                                        }
                                        return null
                                    })
                                }
                                if (parsed.pf_opt_gender) {
                                    parsed.pf_opt_gender.map((p) => {
                                        if (p === v.key) {
                                            selected = true
                                        }
                                        return null
                                    })
                                }
                                return {
                                    ...v,
                                    selected: selected,
                                }
                            }),
                        }
                    }
                    return f
                })

                // console.log('newFilters', newFilters)
                setFilters(newFilters)
            }

            // console.log('allData', allData)

            if (allData && allData.length) {
                setData(allData.flat(1))
                setIsFiltering(false)
            }

            // url cleanup:
            let parsedAfter = qs.parse(window.location.search)

            const keys = Object.keys(parsedAfter)
            const key = keys[0]

            // if we only have 1 query param and it is '_', remove it
            if (keys.length === 1 && key === '_' && parsedAfter[key] === 'pf') {
                // console.log('bingo')
                handleClearAll()
            }
        }

        const handleShowFilters = (e) => {
            // console.log('Filters + clicked', e.target)
            setShowFilters(!showFilters)
        }

        const handleLoadMore = () => {
            // console.log('Load More clicked')
            setIsLoading(true)

            let url

            console.log('queryString in handleLoadMore', queryString)

            if (!queryString) {
                url = `https://services.mybcapps.com/bc-sf-filter/filter?shop=monicaandandyonline.myshopify.com&limit=70&page=${
                    currentPage + 1
                }&collection_scope=${collectionId}&product_available=true&variant_available=true&build_filter_tree=true`
            } else {
                let formattedQueryString = queryString

                formattedQueryString = formattedQueryString.replace(
                    /pf_opt_size=/g,
                    'pf_opt_size[]='
                )
                formattedQueryString = formattedQueryString.replace(
                    /pf_opt_pattern=/g,
                    'pf_opt_pattern[]='
                )
                formattedQueryString = formattedQueryString.replace(
                    /pf_pt_product_type=/g,
                    'pf_pt_product_type[]='
                )

                formattedQueryString = formattedQueryString.replace(
                    /pf_opt_gender=/g,
                    'pf_opt_gender[]='
                )
                formattedQueryString = formattedQueryString.replace(/ /g, '%20')
                formattedQueryString = formattedQueryString.replace('?', '&')

                url = `https://services.mybcapps.com/bc-sf-filter/filter?shop=monicaandandyonline.myshopify.com&limit=70&page=${
                    currentPage + 1
                }&collection_scope=${collectionId}&product_available=true&variant_available=true&build_filter_tree=true${formattedQueryString}`
            }



            getNextProducts(url).then((queriedData) => {
                console.log('queriedData, data, url', queriedData, data, url)

                let newData = queriedData.products.flat(1)



                let allData = [...data, ...newData]

                console.log('newData, allData', newData, allData, url)
                setData(allData)
                setCurrentPage(currentPage + 1)
                setNumProductsRemaining((prevState) => prevState - 70)

                setIsLoading(false)
            })
        }

        const scrollToTop = () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
                /* you can also use 'auto' behaviour
                in place of 'smooth' */
            })
        }

        const NoProductsFound = () => (
            <div className="no-product-found">
                <p className="heading">
                    Uh oh! Looks like there aren't any matching products right
                    now.
                </p>
                <p className="discription">
                    Try again? Use fewer filters or&nbsp;
                    <span
                        className="clear-all-link"
                        onClick={() => handleClearAll()}
                    >
                        clear all
                    </span>
                    .
                </p>
            </div>
        )

        // console.log('numProductsRemaining', numProductsRemaining)

        return (
            <div className="collection-outer">
                <div className="collection-inner">
                    <div className="collection-header">
                        <h1 className="collection-title">
                            {collectionTitle
                                ? collectionTitle
                                : collectionHandle}
                        </h1>
                        <div className="collection-description">
                            {collectionDesc
                                ? ReactHtmlParser(collectionDesc)
                                : ''}
                        </div>
                    </div>
                    <div
                        className={`products-wrap ${
                            isMobile
                                ? 'products-wrap-mobile'
                                : 'products-wrap-desktop'
                        }`}
                    >
                        <BrowserView renderWithFragment={true}>
                            {filters && filters.length ? (
                                <Filters
                                    filters={filters}
                                    variants={variants}
                                    variantsWithInventory={
                                        variantsWithInventoryRef.current
                                    }
                                    handleFilterClick={handleFilterClick}
                                    handleClearAll={handleClearAll}
                                    showFilters={showFilters}
                                    handleShowFilters={handleShowFilters}
                                />
                            ) : (
                                <FiltersPlaceholder />
                            )}
                        </BrowserView>

                        <MobileView renderWithFragment={true}>
                            <div
                                className={`mobile-products-header-outer ${
                                    showFilters ? 'filters-open' : ''
                                }`}
                            >
                                {variants && variants.length && (
                                    <span className="num-items">
                                        {variants && variants.length}&nbsp;
                                        {variants && variants.length === 1
                                            ? 'item'
                                            : 'items'}
                                        &nbsp;out of&nbsp;
                                        {numProducts && numProducts}
                                    </span>
                                )}
                                <div className="mobile-products-header-inner">
                                    <div className="mobile-filters">
                                        {filters && filters.length ? (
                                            <Filters
                                                filters={filters}
                                                variants={variants}
                                                variantsWithInventory={
                                                    variantsWithInventoryRef.current
                                                }
                                                handleFilterClick={
                                                    handleFilterClick
                                                }
                                                handleClearAll={handleClearAll}
                                                showFilters={showFilters}
                                                handleShowFilters={
                                                    handleShowFilters
                                                }
                                            />
                                        ) : (
                                            <FiltersPlaceholder />
                                        )}
                                    </div>
                                    <div className="mobile-sortby">
                                        {variants &&
                                        variants.length &&
                                        typeof variants !== 'undefined' ? (
                                            <SortBy
                                                sortBy={sortBy}
                                                handleSort={handleSort}
                                            />
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </MobileView>

                        <div
                            className={`products-outer ${
                                showFilters ? 'filters-showing' : ''
                            }`}
                        >
                            <div className="products-header">
                                <BrowserView renderWithFragment={true}>
                                    {variants && variants.length && (
                                        <span className="num-items">
                                            {variants && variants.length}&nbsp;
                                            {variants && variants.length === 1
                                                ? 'item'
                                                : 'items'}
                                            &nbsp;out of&nbsp;
                                            {numProducts && numProducts}
                                        </span>
                                    )}

                                    {variants && variants.length ? (
                                        <SortBy
                                            sortBy={sortBy}
                                            handleSort={handleSort}
                                        />
                                    ) : hasProducts ? (
                                        <Loader />
                                    ) : null}
                                </BrowserView>
                            </div>
                            <div
                                className={`products-inner ${
                                    isFiltering ? 'products-filtering' : null
                                }`}
                            >
                                {isFiltering ? <Loader /> : null}
                                <ul
                                    className={`product-list ${
                                        !(variants && variants.length) &&
                                        !hasProducts
                                            ? 'products-not-found'
                                            : ''
                                    }`}
                                >
                                    {variants && variants.length ? (
                                        variants.map((v) => {
                                            if (v.type && v.type === 'Content Card') {
                                                return (
                                                    <ContentCardDemo
                                                        key={`${v.id}`}
                                                        data={v}

                                                    />
                                                )
                                            } else {
                                                const matchingProduct =
                                                products.find((p) => {
                                                    if (p.id === v.product_id) {
                                                        return p
                                                    }
                                                    return null
                                                })
                                            return (
                                                <Variant
                                                    key={`${v.id}`}
                                                    variant={v}
                                                    variants={allVariants}
                                                    product={matchingProduct}
                                                    slug={slug}
                                                />
                                            )
                                            }

                                        })
                                    ) : hasProducts ? (
                                        <CollectionPlaceholder />
                                    ) : (
                                        <NoProductsFound />
                                    )}
                                </ul>
                                {numProductsRemaining &&
                                numProductsRemaining > 0 ? (
                                    <div className="load-more">
                                        <button
                                            className={`load-more-button button ${
                                                isLoading ? 'disabled' : ''
                                            }`}
                                            onClick={handleLoadMore}
                                        >
                                            {isLoading ? (
                                                <div className="button-loader">
                                                    <Loader />
                                                </div>
                                            ) : null}
                                            Load More
                                        </button>
                                    </div>
                                ) : (
                                    !isLoading &&
                                    variants &&
                                    variants.length && (
                                        <div className="all-loaded">
                                            <p>
                                                All products loaded.{' '}
                                                <span
                                                    className="back-to-top"
                                                    onClick={scrollToTop}
                                                >
                                                    Back to top.
                                                </span>
                                            </p>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
)

export default Collection
